<template>
  <div>
    <validation-observer v-slot="{ passes }">
      <b-modal
        id="modal-edit-statements"
        ref="modal-edit-statements"
        centered
        :title="$t('DEBTIA_CHANGE_STATEMENTS')"
        :ok-title="$t('DEBTIA_UPDATE')"
        :no-close-on-backdrop="true"
        cancel-variant="outline-secondary"
        size="lg"
        :cancel-disabled="loader"
        :ok-disabled="loader || errorProblem"
        @show="resetModal"
        @hidden="resetModal"
        @ok.prevent="passes(submitHandler)"
      >
        <b-overlay
          id="overlay-background"
          :show="loader === true"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="md"
          spinner-variant="primary"
          spinner-medium
        >
          <b-alert
            v-if="errorMsg"
            variant="warning"
            show
          >
            <div class="alert-body">
              <span>{{ errorMsg }}</span>
            </div>
          </b-alert>
          <b-card
            aria-hidden="true"
            class="mb-0"
            title=""
          >
            <b-form
              ref="form"
              class="repeater-form"
            >
              <!-- Row Loop -->
              <b-row
                v-for="(item, index) in debtCasestatements"
                :id="index"
                :key="index"
                ref="row"
              >
                <b-col md="4">
                  {{ ($i18n.locale === 'en') ? item.en_name : item.da_name }}
                </b-col>
                <!-- Cost -->
                <b-col
                  md="4"
                >
                  <b-form-group
                    :label="$t('DEBTIA_OLD_AMOUNT')"
                    label-for="category"
                  >
                    <b-form-input
                      :id="'title-'+index"
                      v-model="item.old_amount"
                      type="number"
                      :placeholder="$t('DEBTIA_OLD_AMOUNT')"
                      readonly
                    />
                  </b-form-group>
                </b-col>
                <!-- Cost -->
                <b-col
                  md="4"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="New Value"
                    rules="required|min_value:0"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_NEW_AMOUNT')"
                      label-for="new_amount"
                    >
                      <b-form-input
                        :id="'newamount-'+item.id"
                        v-model="item.new_amount"
                        type="number"
                        :placeholder="$t('DEBTIA_NEW_AMOUNT')"
                        min="0"
                        @change="item.id === '1003' || item.id === '1004'? validateAmount($event, item.id) : ''"
                      />
                      <span
                        style="color: red;"
                      >{{ errors[0] }}</span>
                      <span
                        :id="'newamount-span-'+item.id"
                        style="color: red; display: none;"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <!-- DEB-539 Change Bailif status to false -->
              <b-row
                v-if="showBailifCheckbox === true"
              >
                <b-col
                  md="4"
                >
                  <b-form-checkbox
                    v-model="set_bailif"
                    :checked="bailifValue"
                    name="check-button"
                    inline
                    :disabled="disableBailif"
                  >
                    <span
                      v-if="disableBailif"
                      style="color:red"
                    >
                      {{ $t('DEBTIA_ALREADY_SET_BAILIF_ABILITY') }}
                    </span>
                    <span v-else>
                      {{ $t('DEBTIA_SET_BAILIFF_TO_FALSE') }}
                    </span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-overlay>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BRow, BCol, BFormGroup,
  BForm,
  BFormInput,
  BAlert, BOverlay, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import axios from '@axios'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { min_value } from 'vee-validate/dist/rules'

extend('min_value', min_value)

export default {
  components: {
    BCard,
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    setGeneralLoader: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
    getDetails: {
      type: Function,
      required: true,
    },
    statementsAmount: {
      type: Array,
      required: true,
    },
    showBailifCheckbox: {
      type: Boolean,
      required: false,
    },
    bailifValue: {
      type: Boolean,
      required: false,
    },
    disableBailif: {
      type: Boolean,
      required: false,
    },
    clickChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      required,
      min_value,
      errorMsg: '',
      debtCasestatements: [],
      debtorIndex: 1,
      set_bailif: this.bailifValue,
      errorProblem: false,
      maxCompensationFee: 0,
      maxReminderFee: 0,
    }
  },
  watch: {
    statementsAmount: {
      handler() {
        this.debtCaseStatements()
      },
    },
    modalLoads: {
      handler() {
        this.loader = this.modalLoads
      },
    },
    bailifValue(newVal) {
      this.set_bailif = newVal
    },
    clickChange: {
      handler() {
        this.debtCaseStatements()
        this.getAmount('1003')
        this.getAmount('1004')
      },
    },
  },
  created() {
  },
  methods: {
    getAmount(id) {
      let url = ''
      if (id === '1003') {
        url = '/get-allowed-compensation-fee'
      }
      if (id === '1004') {
        url = '/get-allowed-reminder-fee'
      }
      axios.get(url).then(response => {
        if (response.status === 200) {
          if (id === '1003') {
            this.maxCompensationFee = response.data.data.amount
          }
          if (id === '1004') {
            this.maxReminderFee = response.data.data.amount
          }
        }
      }).catch(error => {
        this.errorMsg = error.response.data.message ? error.response.data.message : error.message
      })
    },
    validateAmount(amount, id) {
      let maxAmount = 0
      if (id === '1003') {
        maxAmount = this.maxCompensationFee
      }
      if (id === '1004') {
        maxAmount = this.maxReminderFee
      }
      if (Number(amount) > Number(maxAmount)) {
        this.errorProblem = true
        document.getElementById(`newamount-span-${id}`).innerHTML = `You can add max ${maxAmount}`
        if (amount) document.getElementById(`newamount-span-${id}`).style.display = 'block'
      } else {
        this.checkAllFields()
        document.getElementById(`newamount-span-${id}`).style.display = 'none'
      }
    },
    checkAllFields() {
      this.errorProblem = false
      this.debtCasestatements.forEach(element => {
        if ((element.id === '1003' || element.id === '1004') && (Number(element.new_amount) > Number(this.maxCompensationFee))) {
          this.errorProblem = true
        }
      })
    },
    debtCaseStatements() {
      const statements = []
      // this.debtCasestatements = [...statements]
      this.statementsAmount.forEach((element, index) => {
        if (element.key !== '0000') {
          const obj = {
            recordIndex: index + 1,
            id: element.jobTaskNo,
            en_name: element.en_name,
            da_name: element.da_name,
            old_amount: element.scheduleTotalPrice - element.paidAmount,
            new_amount: element.scheduleTotalPrice - element.paidAmount,
          }
          statements.push(obj)
        }
      })
      this.debtCasestatements = [...statements]
    },
    resetModal() {
      this.errorMsg = ''
      this.errorProblem = false
      this.maxCompensationFee = 0
      this.maxReminderFee = 0
      this.items = [
        {
          recordIndex: 1,
          id: 0,
          old_amount: 0,
          new_amount: 0,
        },
      ]
    },
    submitHandler() {
      return new Promise((resolve, reject) => {
        this.loader = true
        this.errorMsg = ''
        const url = '/edit-statement'
        const data = []
        data.statements = this.debtCasestatements
        data.debt_case_id = this.caseId
        data.set_bailif = this.set_bailif
        const statementsAmountData = { ...data }
        axios.post(url, statementsAmountData).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.$refs['modal-edit-statements'].hide()
            this.setGeneralLoader()
            this.getDetails()
          }
        }).catch(error => {
          this.errorMsg = error.response.data.message ? error.response.data.message : error.message
          this.loader = false
          reject()
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
